import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/ymparistooppi';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-295" data-mp="pu9kxvjh0423">
      <div className="mx-auto max-w-6xl" data-id="element-296" data-mp="b5wpczoaon84">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-297" data-mp="b55169x11rrv">
          Mitä <em className="text-red-700" style={{
          hyphens: 'manual'
        }} data-id="element-298" data-mp="2604za8xuaiv">YMPÄRISTÖOPPI VALMIS™</em> sisältää?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-299" data-mp="741ofwaa0buv">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-300" data-mp="3ocyggdvozq3x">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-301" data-mp="3tbjec6nh1xp7">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Osat" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-302" data-mp="3cs31zpvx8z23">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-303" data-mp="3ls9lpti7qv9p" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-304" data-mp="2aexfjbyze0kd">{item.number}</span>
                <span className="mt-1 font-serif text-3xl leading-none" data-id="element-305" data-mp="26e3m632rrtk3">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-306" data-mp="9d7nvwwmd0lw">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-307" data-mp="j3anwh25retq">
          <AnimatePresence mode="wait" initial={false} data-id="element-308" data-mp="o0sp1l9xopr6">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-309" data-mp="3mjzlhdjrje79">
              <div className="lg:col-span-5" data-id="element-310" data-mp="59jd75coxowf">
                <p className="text-sm font-semibold text-red-700" data-id="element-311" data-mp="1bshjb76bfoar">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-312" data-mp="1goy9e6x2scqh">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-313" data-mp="31amuj6nbo9z3">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-314" data-mp="2wc36n0p64o43">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-315" data-mp="2rgny8o9xjkf2">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-316" data-mp="2miw6pvd760be">Sisältö</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-317" data-mp="2hlchk0eyo34o">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-318" data-mp="2dizlk3q0njl3">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-319" data-mp="28jczd4s7mt05" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-320" data-mp="6t1h7hgmew1n">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-321" data-mp="1u82xmtif10f">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-322" data-mp="2zm8fwf8i9317">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-323" data-mp="2lnqwuutjoepm">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-324" data-mp="2lpl7ngb3qqfz">
              Mikä tekee YMPÄRISTÖOPPI VALMIS™ -paketista erilaisen?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-325" data-mp="2bwe480zx9kij">
              Koko lukuvuoden ympäristöoppi – järjestettynä ja käyttövalmiina.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-326" data-mp="22ykbt15a3b0n">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-327" data-mp="1syjol44agar6">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-328" data-mp="1szl9s1f0qdmm" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-329" data-mp="1xx4of2fmosf3">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-330" data-mp="1ece68grv4hxr">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}